const MS_PREFIX = 'ms:';

function formatMaterialIcon(name: string): string {
  return `${MS_PREFIX}${name}`;
}

export type PageIconPickerChoice = {
  value: string;
  searchText: string;
  displayLabel: string;
};

type EmojiEntry = { emoji: string; keywords: string };
type MaterialEntry = { name: string; label: string };

const e = (emoji: string, keywords: string): EmojiEntry => ({ emoji, keywords });

/** Emoji with search keywords (name, category, synonyms). */
const EMOJI_CATALOG: EmojiEntry[] = [
  // Documents & tasks
  e('📄', 'document page file paper'),
  e('📃', 'page curl document'),
  e('📑', 'bookmark tabs'),
  e('📋', 'clipboard checklist notes'),
  e('📝', 'memo note write pencil'),
  e('📓', 'notebook'),
  e('📔', 'notebook decorative'),
  e('📒', 'ledger'),
  e('📕', 'book closed red'),
  e('📗', 'book green'),
  e('📘', 'book blue'),
  e('📙', 'book orange'),
  e('📚', 'books library study'),
  e('📖', 'book open read'),
  e('🔖', 'bookmark'),
  e('🏷️', 'label tag'),
  e('✅', 'check done complete yes'),
  e('☑️', 'checkbox check'),
  e('✔️', 'check mark'),
  e('❌', 'cross no wrong'),
  e('⭕', 'circle o'),
  e('📌', 'pin pushpin'),
  e('📍', 'pin location map'),
  e('🗂️', 'card index dividers'),
  e('🗃️', 'file cabinet'),
  e('🗄️', 'filing cabinet'),
  e('📁', 'folder file'),
  e('📂', 'folder open'),
  e('🗑️', 'trash delete'),
  e('♻️', 'recycle'),
  // Stars & hearts
  e('⭐', 'star favorite'),
  e('🌟', 'glowing star'),
  e('✨', 'sparkles magic'),
  e('💫', 'dizzy star'),
  e('🔥', 'fire hot trending'),
  e('💯', 'hundred perfect'),
  e('❤️', 'heart love red'),
  e('🧡', 'heart orange'),
  e('💛', 'heart yellow'),
  e('💚', 'heart green'),
  e('💙', 'heart blue'),
  e('💜', 'heart purple'),
  e('🖤', 'heart black'),
  e('🤍', 'heart white'),
  e('💔', 'broken heart'),
  e('💕', 'two hearts'),
  e('💖', 'sparkling heart'),
  e('💗', 'growing heart'),
  e('💡', 'lightbulb idea'),
  e('🔔', 'bell notification'),
  e('🔕', 'bell slash mute'),
  e('⚠️', 'warning alert'),
  e('🚫', 'prohibited no'),
  e('‼️', 'exclamation'),
  e('❓', 'question'),
  e('❗', 'exclamation mark'),
  e('🔒', 'lock secure'),
  e('🔓', 'unlock open'),
  e('🔑', 'key'),
  // Food & drink
  e('🍇', 'grape vineyard wine fruit'),
  e('🍈', 'melon'),
  e('🍉', 'watermelon'),
  e('🍊', 'orange tangerine citrus'),
  e('🍋', 'lemon citrus'),
  e('🍌', 'banana fruit'),
  e('🍍', 'pineapple'),
  e('🥭', 'mango'),
  e('🍎', 'apple red fruit'),
  e('🍏', 'apple green'),
  e('🍐', 'pear'),
  e('🍑', 'peach'),
  e('🍒', 'cherry'),
  e('🍓', 'strawberry berry'),
  e('🫐', 'blueberry'),
  e('🥝', 'kiwi'),
  e('🍅', 'tomato'),
  e('🫒', 'olive'),
  e('🥥', 'coconut'),
  e('🥑', 'avocado'),
  e('🍆', 'eggplant'),
  e('🥔', 'potato'),
  e('🥕', 'carrot vegetable'),
  e('🌽', 'corn'),
  e('🌶️', 'pepper hot chili'),
  e('🫑', 'bell pepper'),
  e('🥒', 'cucumber'),
  e('🥬', 'lettuce greens leafy garden'),
  e('🥦', 'broccoli'),
  e('🧄', 'garlic'),
  e('🧅', 'onion'),
  e('🍄', 'mushroom'),
  e('🥜', 'peanuts nuts'),
  e('🫘', 'beans'),
  e('🌰', 'chestnut'),
  e('🍞', 'bread bakery'),
  e('🥐', 'croissant'),
  e('🥖', 'baguette bread'),
  e('🥨', 'pretzel'),
  e('🥯', 'bagel'),
  e('🥞', 'pancakes breakfast'),
  e('🧇', 'waffle'),
  e('🧀', 'cheese dairy'),
  e('🍖', 'meat bone'),
  e('🍗', 'poultry chicken leg'),
  e('🥩', 'steak meat beef'),
  e('🥓', 'bacon'),
  e('🍔', 'burger hamburger'),
  e('🍟', 'fries'),
  e('🍕', 'pizza'),
  e('🌭', 'hotdog'),
  e('🥪', 'sandwich'),
  e('🌮', 'taco mexican'),
  e('🌯', 'burrito wrap'),
  e('🫔', 'tamale'),
  e('🥙', 'stuffed flatbread'),
  e('🧆', 'falafel'),
  e('🥚', 'egg'),
  e('🍳', 'cooking egg pan chef'),
  e('🥘', 'paella pan food'),
  e('🍲', 'stew pot soup'),
  e('🫕', 'fondue'),
  e('🥣', 'bowl cereal'),
  e('🥗', 'salad green'),
  e('🍿', 'popcorn movie'),
  e('🧈', 'butter'),
  e('🧂', 'salt seasoning'),
  e('🥫', 'canned food'),
  e('🍱', 'bento lunch'),
  e('🍘', 'rice cracker'),
  e('🍙', 'rice ball'),
  e('🍚', 'rice'),
  e('🍛', 'curry rice'),
  e('🍜', 'noodles ramen soup'),
  e('🍝', 'spaghetti pasta'),
  e('🍠', 'sweet potato'),
  e('🍢', 'oden'),
  e('🍣', 'sushi fish'),
  e('🍤', 'fried shrimp'),
  e('🍥', 'fish cake'),
  e('🥮', 'moon cake'),
  e('🍡', 'dango'),
  e('🥟', 'dumpling'),
  e('🥠', 'fortune cookie'),
  e('🥡', 'takeout box'),
  e('🦀', 'crab seafood'),
  e('🦞', 'lobster seafood'),
  e('🦐', 'shrimp seafood'),
  e('🦑', 'squid'),
  e('🦪', 'oyster'),
  e('🍦', 'ice cream dessert'),
  e('🍧', 'shaved ice'),
  e('🍨', 'ice cream bowl'),
  e('🍩', 'donut'),
  e('🍪', 'cookie'),
  e('🎂', 'birthday cake'),
  e('🍰', 'cake dessert shortcake'),
  e('🧁', 'cupcake'),
  e('🥧', 'pie'),
  e('🍫', 'chocolate'),
  e('🍬', 'candy sweet'),
  e('🍭', 'lollipop'),
  e('🍮', 'custard pudding'),
  e('🍯', 'honey'),
  e('🍼', 'baby bottle'),
  e('🥛', 'milk glass dairy'),
  e('☕', 'coffee cafe drink'),
  e('🫖', 'teapot tea'),
  e('🍵', 'tea cup matcha'),
  e('🍶', 'sake'),
  e('🍾', 'champagne bottle celebration'),
  e('🍷', 'wine glass winemaking vineyard'),
  e('🍸', 'cocktail'),
  e('🍹', 'tropical drink'),
  e('🍺', 'beer mug'),
  e('🍻', 'beers cheers'),
  e('🥂', 'champagne clink toast'),
  e('🥃', 'whiskey tumbler spirits'),
  e('🫗', 'pour drink'),
  e('🧃', 'juice box'),
  e('🧉', 'mate'),
  e('🧊', 'ice cube'),
  e('👨‍🍳', 'chef cook recipe kitchen'),
  // Nature & plants
  e('🌱', 'seedling sprout plant'),
  e('🪴', 'potted plant houseplant'),
  e('🌲', 'evergreen tree pine'),
  e('🌳', 'deciduous tree trees'),
  e('🌴', 'palm tree tropical'),
  e('🌵', 'cactus desert'),
  e('🌾', 'sheaf rice grain farm'),
  e('🌿', 'herb leaf'),
  e('☘️', 'shamrock clover'),
  e('🍀', 'four leaf clover luck'),
  e('🍁', 'maple leaf fall autumn'),
  e('🍂', 'fallen leaf autumn'),
  e('🍃', 'leaf wind'),
  e('🌺', 'hibiscus flower'),
  e('🌻', 'sunflower'),
  e('🌼', 'blossom flower'),
  e('🌷', 'tulip flower'),
  e('🌹', 'rose flower'),
  e('💐', 'bouquet flowers'),
  e('🪻', 'hyacinth'),
  e('🪷', 'lotus'),
  e('🌍', 'earth globe europe africa'),
  e('🌎', 'earth americas'),
  e('🌏', 'earth asia'),
  e('🌋', 'volcano'),
  e('🗻', 'mount fuji mountain'),
  e('🏔️', 'snow mountain'),
  e('⛰️', 'mountain'),
  e('🏕️', 'camping tent outdoors'),
  e('🏖️', 'beach'),
  e('🏜️', 'desert'),
  e('🏝️', 'island'),
  e('🌊', 'wave ocean water'),
  e('💧', 'droplet water'),
  e('🌫️', 'fog'),
  // Weather
  e('☀️', 'sun sunny weather'),
  e('🌤', 'sun cloud partly cloudy'),
  e('⛅', 'sun behind cloud'),
  e('🌥', 'sun small cloud'),
  e('☁️', 'cloud'),
  e('🌦', 'sun rain shower'),
  e('🌧', 'rain cloud rainy'),
  e('⛈️', 'storm thunder'),
  e('🌩', 'lightning cloud'),
  e('🌨', 'snow cloud'),
  e('❄️', 'snowflake winter'),
  e('☃️', 'snowman'),
  e('⛄', 'snowman without snow'),
  e('🌬', 'wind'),
  e('🌪', 'tornado'),
  e('🌈', 'rainbow'),
  e('🌙', 'moon crescent night'),
  e('🌛', 'first quarter moon'),
  e('🌜', 'last quarter moon'),
  e('⭐', 'star night'),
  e('🌟', 'glowing star'),
  e('✨', 'sparkle'),
  e('☄️', 'comet'),
  e('🔭', 'telescope observe astronomy science'),
  e('🧪', 'test tube lab science'),
  e('🔬', 'microscope science lab'),
  e('🧬', 'dna genetics'),
  // Animals
  e('🐕', 'dog pet'),
  e('🐩', 'poodle dog'),
  e('🦮', 'guide dog'),
  e('🐕‍🦺', 'service dog'),
  e('🐈', 'cat pet'),
  e('🐈‍⬛', 'black cat'),
  e('🐓', 'rooster chicken farm'),
  e('🐔', 'chicken poultry'),
  e('🐣', 'chick hatching'),
  e('🐤', 'baby chick'),
  e('🐥', 'front chick'),
  e('🦆', 'duck'),
  e('🦅', 'eagle bird'),
  e('🦉', 'owl bird'),
  e('🦇', 'bat'),
  e('🐺', 'wolf'),
  e('🦊', 'fox'),
  e('🦝', 'raccoon'),
  e('🐻', 'bear'),
  e('🐼', 'panda'),
  e('🐨', 'koala'),
  e('🐯', 'tiger'),
  e('🦁', 'lion'),
  e('🐮', 'cow cattle'),
  e('🐷', 'pig'),
  e('🐗', 'boar'),
  e('🐴', 'horse'),
  e('🦄', 'unicorn'),
  e('🐝', 'bee honey insect'),
  e('🪲', 'beetle bug'),
  e('🐛', 'bug caterpillar'),
  e('🦋', 'butterfly insect'),
  e('🐌', 'snail'),
  e('🐞', 'ladybug'),
  e('🐜', 'ant'),
  e('🪱', 'worm'),
  e('🦟', 'mosquito'),
  e('🕷️', 'spider'),
  e('🦂', 'scorpion'),
  e('🐢', 'turtle'),
  e('🐍', 'snake'),
  e('🦎', 'lizard'),
  e('🐙', 'octopus'),
  e('🦑', 'squid'),
  e('🦐', 'shrimp'),
  e('🦞', 'lobster'),
  e('🐠', 'tropical fish'),
  e('🐟', 'fish seafood'),
  e('🐡', 'blowfish'),
  e('🦈', 'shark'),
  e('🐳', 'whale'),
  e('🐬', 'dolphin'),
  // Home & tools
  e('🏠', 'house home'),
  e('🏡', 'house garden home'),
  e('🏘️', 'houses'),
  e('🏚️', 'derelict house'),
  e('🏗️', 'building construction'),
  e('🏭', 'factory industrial'),
  e('🏢', 'office building'),
  e('🏬', 'department store'),
  e('🏪', 'convenience store shop'),
  e('🏫', 'school'),
  e('🏥', 'hospital medical'),
  e('🏦', 'bank'),
  e('🏨', 'hotel'),
  e('🏛️', 'classical building'),
  e('⛪', 'church'),
  e('🕌', 'mosque'),
  e('🛕', 'hindu temple'),
  e('⛩️', 'shrine'),
  e('🗼', 'tower'),
  e('🗽', 'statue liberty'),
  e('🔧', 'wrench tool repair fix home'),
  e('🔨', 'hammer build'),
  e('⚒️', 'hammer pick'),
  e('🛠', 'hammer wrench tools'),
  e('⛏️', 'pick mining'),
  e('🪓', 'axe wood'),
  e('🪚', 'saw carpentry'),
  e('🔩', 'nut bolt'),
  e('⚙️', 'gear settings cog'),
  e('🧰', 'toolbox'),
  e('🧲', 'magnet'),
  e('⚡', 'lightning electric power bolt'),
  e('🔋', 'battery'),
  e('🔌', 'electric plug'),
  e('💡', 'bulb idea light'),
  e('🕯️', 'candle'),
  e('🪔', 'diya lamp'),
  e('🧯', 'fire extinguisher safety'),
  e('🚿', 'shower bathroom'),
  e('🛁', 'bathtub'),
  e('🚽', 'toilet plumbing'),
  e('🧹', 'broom clean'),
  e('🧺', 'basket laundry'),
  e('🧻', 'toilet paper'),
  e('🪣', 'bucket'),
  e('🧼', 'soap'),
  e('🪥', 'toothbrush'),
  e('🛋️', 'couch sofa'),
  e('🪑', 'chair'),
  e('🛏️', 'bed'),
  e('🚪', 'door'),
  e('🪟', 'window'),
  // Transport
  e('🚗', 'car automobile'),
  e('🚕', 'taxi'),
  e('🚙', 'suv car'),
  e('🚌', 'bus'),
  e('🚎', 'trolleybus'),
  e('🏎️', 'race car'),
  e('🚓', 'police car'),
  e('🚑', 'ambulance'),
  e('🚒', 'fire engine truck'),
  e('🚐', 'minibus van'),
  e('🛻', 'pickup truck'),
  e('🚚', 'delivery truck'),
  e('🚛', 'articulated truck semi'),
  e('🚜', 'tractor farm'),
  e('🏍️', 'motorcycle'),
  e('🛵', 'scooter'),
  e('🚲', 'bicycle bike'),
  e('🛴', 'kick scooter'),
  e('🚂', 'locomotive train'),
  e('🚆', 'train'),
  e('🚇', 'metro subway'),
  e('✈️', 'airplane plane travel'),
  e('🛫', 'departure airplane'),
  e('🛬', 'arrival airplane'),
  e('🛩️', 'small airplane'),
  e('🚁', 'helicopter'),
  e('🚀', 'rocket space'),
  e('🛸', 'ufo flying saucer'),
  e('⛵', 'sailboat boat sailing'),
  e('🚤', 'speedboat'),
  e('🛥️', 'motor boat'),
  e('🛳️', 'passenger ship'),
  e('⛴️', 'ferry'),
  e('🚢', 'ship'),
  e('⚓', 'anchor boat'),
  e('🗺️', 'map world travel'),
  e('🧭', 'compass navigation'),
  e('⛽', 'fuel gas pump'),
  // Shopping & money
  e('🛒', 'shopping cart grocery store'),
  e('🛍️', 'shopping bags'),
  e('💳', 'credit card payment'),
  e('💰', 'money bag'),
  e('🪙', 'coin money'),
  e('💵', 'dollar money cash'),
  e('💴', 'yen'),
  e('💶', 'euro'),
  e('💷', 'pound'),
  e('💸', 'money wings spend'),
  e('🧾', 'receipt'),
  e('📊', 'chart bar graph stats'),
  e('📈', 'chart increasing trend'),
  e('📉', 'chart decreasing'),
  e('💼', 'briefcase work business'),
  // Sports & fun
  e('⚽', 'soccer ball sport'),
  e('🏀', 'basketball'),
  e('🏈', 'football american'),
  e('⚾', 'baseball'),
  e('🎾', 'tennis'),
  e('🏐', 'volleyball'),
  e('🏉', 'rugby'),
  e('🎱', 'pool billiards'),
  e('🏓', 'ping pong'),
  e('🏸', 'badminton'),
  e('⛳', 'golf'),
  e('🎯', 'target dart'),
  e('🎣', 'fishing pole'),
  e('🤿', 'diving'),
  e('🎿', 'ski snow'),
  e('⛷️', 'skier'),
  e('🏂', 'snowboard'),
  e('🏋️', 'weight lifting gym'),
  e('🤸', 'cartwheel gymnastics'),
  e('🧘', 'yoga meditation'),
  e('🏃', 'runner running exercise'),
  e('🚶', 'walk walking'),
  e('🧗', 'climbing'),
  e('🚵', 'mountain bike'),
  e('🏊', 'swimmer pool'),
  e('⛺', 'tent camping'),
  e('🎪', 'circus'),
  e('🎭', 'performing arts theater'),
  e('🎨', 'art palette paint'),
  e('🎬', 'clapper movie film'),
  e('🎥', 'movie camera video'),
  e('📷', 'camera photo'),
  e('📸', 'camera flash photo'),
  e('📹', 'video camera'),
  e('🎵', 'music note'),
  e('🎶', 'music notes'),
  e('🎸', 'guitar music'),
  e('🎹', 'piano keyboard'),
  e('🎺', 'trumpet'),
  e('🎻', 'violin'),
  e('🥁', 'drum'),
  e('🎮', 'video game controller'),
  e('🕹️', 'joystick game'),
  e('🎲', 'dice game'),
  e('🧩', 'puzzle piece'),
  e('♟️', 'chess'),
  e('🎳', 'bowling'),
  // Celebration & gifts
  e('🎁', 'gift present'),
  e('🎉', 'party popper celebration'),
  e('🎊', 'confetti ball'),
  e('🎈', 'balloon party'),
  e('🎀', 'ribbon'),
  e('🎄', 'christmas tree holiday'),
  e('🎃', 'jack o lantern halloween pumpkin'),
  e('👻', 'ghost halloween'),
  e('🎆', 'fireworks'),
  e('🎇', 'sparkler'),
  e('🧨', 'firecracker'),
  e('💒', 'wedding chapel'),
  e('🥳', 'partying face celebrate'),
  e('🎂', 'birthday cake'),
  // People & family
  e('👶', 'baby child'),
  e('👧', 'girl child kid'),
  e('👦', 'boy child kid'),
  e('👩', 'woman person'),
  e('👨', 'man person'),
  e('👴', 'older man grandpa'),
  e('👵', 'older woman grandma'),
  e('👨‍👩‍👧', 'family parents child'),
  e('👨‍👩‍👧‍👦', 'family children'),
  e('👪', 'family unit'),
  e('🤝', 'handshake deal'),
  e('👋', 'wave hello'),
  e('🙏', 'pray thanks please'),
  e('💪', 'muscle strong'),
  e('🧠', 'brain think'),
  e('👀', 'eyes look see'),
  e('💬', 'speech bubble chat talk'),
  e('📞', 'phone call telephone'),
  e('📱', 'mobile phone cell'),
  e('💻', 'laptop computer'),
  e('🖥️', 'desktop computer'),
  e('⌨️', 'keyboard'),
  e('🖨️', 'printer'),
  e('📡', 'satellite antenna'),
  e('📺', 'television tv'),
  e('📻', 'radio'),
  e('⏰', 'alarm clock time'),
  e('⏱️', 'stopwatch timer'),
  e('📅', 'calendar date'),
  e('📆', 'tear off calendar'),
  e('✏️', 'pencil edit write'),
  e('✒️', 'pen black'),
  e('🖊️', 'pen'),
  e('🖋️', 'fountain pen'),
  e('📎', 'paperclip'),
  e('🔗', 'link chain'),
  e('✂️', 'scissors cut'),
];

const MATERIAL_CATALOG: MaterialEntry[] = [
  { name: 'description', label: 'Document' },
  { name: 'article', label: 'Article' },
  { name: 'note', label: 'Note' },
  { name: 'note_add', label: 'New note' },
  { name: 'edit_note', label: 'Edit note' },
  { name: 'sticky_note_2', label: 'Sticky note' },
  { name: 'checklist', label: 'Checklist' },
  { name: 'checklist_rtl', label: 'Checklist RTL' },
  { name: 'task_alt', label: 'Done' },
  { name: 'done_all', label: 'All done' },
  { name: 'pending_actions', label: 'Pending' },
  { name: 'star', label: 'Star' },
  { name: 'star_border', label: 'Star outline' },
  { name: 'favorite', label: 'Heart' },
  { name: 'favorite_border', label: 'Heart outline' },
  { name: 'bookmark', label: 'Bookmark' },
  { name: 'label', label: 'Label' },
  { name: 'flag', label: 'Flag' },
  { name: 'home', label: 'Home' },
  { name: 'cottage', label: 'Cottage' },
  { name: 'house', label: 'House' },
  { name: 'apartment', label: 'Apartment' },
  { name: 'cabin', label: 'Cabin' },
  { name: 'villa', label: 'Villa' },
  { name: 'yard', label: 'Yard' },
  { name: 'grass', label: 'Grass' },
  { name: 'forest', label: 'Forest' },
  { name: 'park', label: 'Park' },
  { name: 'nature', label: 'Nature' },
  { name: 'landscape', label: 'Landscape' },
  { name: 'terrain', label: 'Terrain' },
  { name: 'agriculture', label: 'Farm' },
  { name: 'eco', label: 'Eco' },
  { name: 'compost', label: 'Compost' },
  { name: 'local_florist', label: 'Flowers' },
  { name: 'filter_vintage', label: 'Plants' },
  { name: 'spa', label: 'Spa' },
  { name: 'water_drop', label: 'Water' },
  { name: 'opacity', label: 'Water opacity' },
  { name: 'waves', label: 'Waves' },
  { name: 'pool', label: 'Pool' },
  { name: 'wb_sunny', label: 'Sun' },
  { name: 'wb_cloudy', label: 'Cloudy' },
  { name: 'cloud', label: 'Cloud' },
  { name: 'thunderstorm', label: 'Storm' },
  { name: 'ac_unit', label: 'Snow AC' },
  { name: 'grain', label: 'Grain' },
  { name: 'breakfast_dining', label: 'Breakfast' },
  { name: 'lunch_dining', label: 'Lunch' },
  { name: 'dinner_dining', label: 'Dinner' },
  { name: 'restaurant', label: 'Restaurant' },
  { name: 'restaurant_menu', label: 'Menu' },
  { name: 'local_dining', label: 'Dining' },
  { name: 'local_grocery_store', label: 'Grocery' },
  { name: 'store', label: 'Store' },
  { name: 'storefront', label: 'Storefront' },
  { name: 'kitchen', label: 'Kitchen' },
  { name: 'microwave', label: 'Microwave' },
  { name: 'blender', label: 'Blender' },
  { name: 'set_meal', label: 'Meal' },
  { name: 'ramen_dining', label: 'Ramen' },
  { name: 'local_cafe', label: 'Cafe' },
  { name: 'coffee', label: 'Coffee' },
  { name: 'wine_bar', label: 'Wine bar' },
  { name: 'liquor', label: 'Spirits' },
  { name: 'local_bar', label: 'Bar' },
  { name: 'icecream', label: 'Ice cream' },
  { name: 'cake', label: 'Cake' },
  { name: 'egg', label: 'Egg' },
  { name: 'egg_alt', label: 'Egg alt' },
  { name: 'shopping_cart', label: 'Cart' },
  { name: 'shopping_bag', label: 'Shopping bag' },
  { name: 'shopping_basket', label: 'Basket' },
  { name: 'add_shopping_cart', label: 'Add to cart' },
  { name: 'payments', label: 'Payments' },
  { name: 'account_balance_wallet', label: 'Wallet' },
  { name: 'savings', label: 'Savings' },
  { name: 'attach_money', label: 'Money' },
  { name: 'build', label: 'Build' },
  { name: 'handyman', label: 'Handyman' },
  { name: 'construction', label: 'Construction' },
  { name: 'hardware', label: 'Hardware' },
  { name: 'home_repair_service', label: 'Repair' },
  { name: 'precision_manufacturing', label: 'Welding manufacturing' },
  { name: 'engineering', label: 'Engineering' },
  { name: 'architecture', label: 'Architecture' },
  { name: 'carpenter', label: 'Carpenter' },
  { name: 'plumbing', label: 'Plumbing' },
  { name: 'electrical_services', label: 'Electric' },
  { name: 'hvac', label: 'HVAC' },
  { name: 'roofing', label: 'Roof' },
  { name: 'foundation', label: 'Foundation' },
  { name: 'fence', label: 'Fence' },
  { name: 'deck', label: 'Deck' },
  { name: 'garage', label: 'Garage' },
  { name: 'warehouse', label: 'Warehouse' },
  { name: 'shed', label: 'Shed' },
  { name: 'directions_car', label: 'Car' },
  { name: 'directions_bus', label: 'Bus' },
  { name: 'directions_bike', label: 'Bike directions' },
  { name: 'two_wheeler', label: 'Motorcycle' },
  { name: 'local_shipping', label: 'Shipping truck' },
  { name: 'airport_shuttle', label: 'Shuttle' },
  { name: 'flight', label: 'Flight' },
  { name: 'directions_boat', label: 'Boat' },
  { name: 'sailing', label: 'Sailing' },
  { name: 'anchor', label: 'Anchor' },
  { name: 'train', label: 'Train' },
  { name: 'tram', label: 'Tram' },
  { name: 'hiking', label: 'Hiking' },
  { name: 'camping', label: 'Camping' },
  { name: 'kayaking', label: 'Kayak' },
  { name: 'downhill_skiing', label: 'Ski' },
  { name: 'snowboarding', label: 'Snowboard' },
  { name: 'pets', label: 'Pets' },
  { name: 'cruelty_free', label: 'Animals' },
  { name: 'pest_control', label: 'Pest' },
  { name: 'child_care', label: 'Kids childcare' },
  { name: 'escalator_warning', label: 'Baby' },
  { name: 'family_restroom', label: 'Family' },
  { name: 'groups', label: 'Groups' },
  { name: 'person', label: 'Person' },
  { name: 'celebration', label: 'Party' },
  { name: 'cake', label: 'Birthday cake' },
  { name: 'redeem', label: 'Gift' },
  { name: 'card_giftcard', label: 'Gift card' },
  { name: 'movie', label: 'Movie' },
  { name: 'theaters', label: 'Theater' },
  { name: 'music_note', label: 'Music' },
  { name: 'library_music', label: 'Music library' },
  { name: 'headphones', label: 'Headphones' },
  { name: 'photo_camera', label: 'Camera' },
  { name: 'photo_library', label: 'Photos' },
  { name: 'videocam', label: 'Video' },
  { name: 'menu_book', label: 'Book' },
  { name: 'auto_stories', label: 'Stories' },
  { name: 'school', label: 'School' },
  { name: 'history_edu', label: 'Education' },
  { name: 'work', label: 'Work' },
  { name: 'business_center', label: 'Business' },
  { name: 'science', label: 'Science' },
  { name: 'biotech', label: 'Biotech lab' },
  { name: 'experiment', label: 'Experiment' },
  { name: 'visibility', label: 'Observe eye' },
  { name: 'travel_explore', label: 'Explore' },
  { name: 'explore', label: 'Compass explore' },
  { name: 'map', label: 'Map' },
  { name: 'place', label: 'Place pin' },
  { name: 'pin_drop', label: 'Pin drop' },
  { name: 'lightbulb', label: 'Idea' },
  { name: 'tips_and_updates', label: 'Tips' },
  { name: 'bolt', label: 'Power bolt' },
  { name: 'battery_charging_full', label: 'Battery' },
  { name: 'solar_power', label: 'Solar' },
  { name: 'health_and_safety', label: 'Safety' },
  { name: 'medical_services', label: 'Medical' },
  { name: 'medication', label: 'Medication' },
  { name: 'fitness_center', label: 'Gym' },
  { name: 'self_improvement', label: 'Meditation' },
  { name: 'calendar_month', label: 'Calendar' },
  { name: 'event', label: 'Event' },
  { name: 'schedule', label: 'Schedule clock' },
  { name: 'alarm', label: 'Alarm' },
  { name: 'timer', label: 'Timer' },
  { name: 'mail', label: 'Mail' },
  { name: 'inbox', label: 'Inbox' },
  { name: 'send', label: 'Send' },
  { name: 'chat', label: 'Chat' },
  { name: 'forum', label: 'Forum' },
  { name: 'comment', label: 'Comment' },
  { name: 'notifications', label: 'Notifications' },
  { name: 'folder', label: 'Folder' },
  { name: 'folder_open', label: 'Folder open' },
  { name: 'create_new_folder', label: 'New folder' },
  { name: 'inventory_2', label: 'Box inventory' },
  { name: 'archive', label: 'Archive' },
  { name: 'delete', label: 'Delete' },
  { name: 'settings', label: 'Settings' },
  { name: 'tune', label: 'Tune sliders' },
  { name: 'search', label: 'Search' },
  { name: 'help', label: 'Help' },
  { name: 'info', label: 'Info' },
  { name: 'warning', label: 'Warning' },
  { name: 'error', label: 'Error' },
  { name: 'lock', label: 'Lock' },
  { name: 'key', label: 'Key' },
];

let catalogCache: PageIconPickerChoice[] | null = null;

export function buildPageIconCatalog(): PageIconPickerChoice[] {
  if (catalogCache) return catalogCache;

  const seen = new Set<string>();
  const out: PageIconPickerChoice[] = [];

  for (const { emoji, keywords } of EMOJI_CATALOG) {
    if (seen.has(emoji)) continue;
    seen.add(emoji);
    out.push({
      value: emoji,
      searchText: `${keywords} ${emoji} emoji`.toLowerCase(),
      displayLabel: keywords.split(/\s+/)[0] ?? 'emoji',
    });
  }

  for (const { name, label } of MATERIAL_CATALOG) {
    const value = formatMaterialIcon(name);
    if (seen.has(value)) continue;
    seen.add(value);
    const nameWords = name.replace(/_/g, ' ');
    out.push({
      value,
      searchText: `${label} ${nameWords} icon symbol material`.toLowerCase(),
      displayLabel: label,
    });
  }

  out.sort((a, b) => a.displayLabel.localeCompare(b.displayLabel, undefined, { sensitivity: 'base' }));
  catalogCache = out;
  return out;
}

export function filterPageIconCatalog(
  catalog: PageIconPickerChoice[],
  query: string
): PageIconPickerChoice[] {
  const q = query.trim().toLowerCase();
  if (!q) return catalog;
  const terms = q.split(/\s+/).filter(Boolean);
  return catalog.filter(choice => {
    const hay = choice.searchText;
    return terms.every(term => hay.includes(term));
  });
}
